import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-help-pdf',
  templateUrl: './help-pdf.component.html',
  styleUrls: ['./help-pdf.component.scss']
})
export class HelpPdfComponent implements OnInit {


  helpPage = 2;

  FAQsDef:any = {
    title:"FAQs",
    tableName:"faqs",
    readOnly:true,
    pagedOn:true,
    filterOn:true,
    sortOn:true,

    fields:[
      { name: "id",
        label: "Id",
        type: "string",
        readonly : true
      },
      { name: "class",
        label: "Class",
        type: "string",
        readonly : true

      },
      { name: "group",
        label: "Group",
        type: "string",
        readonly : true
      },
      { name: "grouporder",
        label: "GroupOrder",
        type: "string",
        readonly : true
      },
      { name: "question",
        label: "Question",
        type: "string",
        readonly : true
      },
      { name: "questionorder",
        label: "QuestionOrder",
        type: "string",
        readonly : true
      },
      { name: "answer",
        label: "Answer",
        type: "string",
        readonly : true
      },
      { name: "reference",
        label: "Reference",
        type: "string",
        readonly : true
      },
      { name: "createdby",
        label: "Created By",
        type: "string",
        align: "center",
        readonly : true
      },
      { name: "created",
        label: "Created",
        type: "datetime",
        align: "center",
        readonly : true
      },
    ]
  }

  ContributionGuidelines = {
    heads:["What are we doing", "Who is doing it"],
    bodys:[{
      what: "Leading the effort",
      who: "The Account Executive is accountable for the Estate Maps"
    },{
      what: "Gathering the information",
      who: "The full account team, along with data sources that are associated with the account, should provide information that is needed to maintain the Estate Maps"
    },{
      what: "Populating the map",
      who: "Those team members closest to the information source, and those with significant awareness, should update the Maps and review changes with the account team"
    },{
      what: "Maximizing value",
      who: "Account team members, based on role, use the Estate Maps to inform their interactions with the customer - it's a source for information and ideas to guide customer conversations, not a template for unsolicited proposals"
    }]
  };

  constructor(public dialog: MatDialog,
    public dialogRef: MatDialogRef<HelpPdfComponent>,    
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {

    if(this.data["helpPage"]){
      let p = this.data["helpPage"]
      
      // Should have a better way to do this! have a map somewhere
      // but for now page2 is ServiceAsset, page3 is health 
      if(p==2) this.helpPage = 0;
      if(p==3) this.helpPage = 1;
    }

  }

  close(): void {
    this.dialogRef.close();
  }

}
